import { GelTheme } from 'components/GelTheme';
import { FlexBox } from 'components/Layout';
import { FC } from 'react';
import styled from 'styled-components';

interface Props {
  current?: number;
  limit: number;
  maxWidth?: string;
}

const CharacterCounterBox = styled(FlexBox)<Pick<Props, 'maxWidth'>>`
  color: ${GelTheme.color('grey')};
  font-size: ${GelTheme.fontSize('xs')};
  max-width: ${(props) => props.maxWidth};
`;

export const CharacterCounter: FC<Props> = ({ current, limit, maxWidth }) => {
  const text = limit != null ? `${current ?? 0}/${limit}` : `${current} character${current !== 1 ? 's' : ''}`;

  return (
    <CharacterCounterBox mt={0.5} justifyContent="flex-end" maxWidth={maxWidth}>
      {text}
    </CharacterCounterBox>
  );
};
